var _rect, _text, _text2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNovenovefoodIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 120,
    height: 120,
    rx: 28,
    fill: "#FFD500"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 60,
    y: 50,
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 36,
    fontWeight: "bold",
    fill: "#000",
    textAnchor: "middle",
    dominantBaseline: "middle"
  }, "\n    99\n  ")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 60,
    y: 80,
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 18,
    fontWeight: "bold",
    fill: "#000",
    textAnchor: "middle",
    dominantBaseline: "middle"
  }, "\n    food\n  ")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNovenovefoodIcon);
export default __webpack_public_path__ + "static/media/novenovefoodIcon.3151a9e306ac6ddc0ba933ef589841be.svg";
export { ForwardRef as ReactComponent };